const KIB = 1024;
const MIB = 1024 * 1024;
const GIB = 1024 * 1024 * 1024;

/** Average, minimum and maximum RSS already formatted for a table cell or the process block. */
export interface AssignmentRssView {
  average: string;
  minimum: string;
  maximum: string;
}

/** Reads the rollup the operations list and the process-group row both return. */
export function readAssignmentRss(item: object | null | undefined): AssignmentRssView | null {
  if (!item) {
    return null;
  }
  const row = item as {
    rssAverageBytes?: number | null;
    rssMinBytes?: number | null;
    rssMaxBytes?: number | null;
  };
  if (row.rssAverageBytes == null || row.rssMinBytes == null || row.rssMaxBytes == null) {
    return null;
  }
  return {
    average: formatRssBytes(row.rssAverageBytes),
    minimum: formatRssBytes(row.rssMinBytes),
    maximum: formatRssBytes(row.rssMaxBytes),
  };
}

function formatRssBytes(bytes: number): string {
  if (bytes >= GIB) {
    return `${(bytes / GIB).toFixed(2)} GiB`;
  }
  if (bytes >= MIB) {
    return `${(bytes / MIB).toFixed(2)} MiB`;
  }
  if (bytes >= KIB) {
    return `${(bytes / KIB).toFixed(2)} KiB`;
  }
  return `${bytes} B`;
}
